import { FC, useMemo } from 'react'
import ConfettiIcon from '../../../src/assets/assistantIcon/confetti.svg?react'
import AppleIcon from '../../../src/assets/assistantIcon/apple.svg?react'
import MegaphoneIcon from '../../../src/assets/assistantIcon/megaphone.svg?react'
import SmileIcon from '../../../src/assets/assistantIcon/smile.svg?react'
import PlayingCardsIcon from '../../../src/assets/assistantIcon/playingСards.svg?react'
import CommentUserIcon from '../../../src/assets/assistantIcon/commentUser.svg?react'
import MoonIcon from '../../../src/assets/assistantIcon/moon.svg?react'
import SubtitlesIcon from '../../../src/assets/assistantIcon/subtitles.svg?react'
import TrophyIcon from '../../../src/assets/assistantIcon/trophy.svg?react'
import BookIcon from '../../../src/assets/assistantIcon/book.svg?react'
import ShoppingCartCheckIcon from '../../../src/assets/assistantIcon/shoppingCartCheck.svg?react'
import VideoCameraIcon from '../../../src/assets/assistantIcon/videoCamera.svg?react'
import BriefcaseIcon from '../../../src/assets/assistantIcon/briefcase.svg?react'
import ChartHistogramIcon from '../../../src/assets/assistantIcon/chartHistogram.svg?react'
import PictureIcon from '../../../src/assets/assistantIcon/picture.svg?react'
import TransformIcon from '../../../src/assets/assistantIcon/transform.svg?react'
import PawIcon from '../../../src/assets/assistantIcon/paw.svg?react'
import HeadSideThinkingIcon from '../../../src/assets/assistantIcon/headSideThinking.svg?react'
import TreatmentIcon from '../../../src/assets/assistantIcon/treatment.svg?react'
import LabelIcon from '../../../src/assets/assistantIcon/label.svg?react'
import TimeQuarterToIcon from '../../../src/assets/assistantIcon/timeQuarterTo.svg?react'
import GymIcon from '../../../src/assets/assistantIcon/gym.svg?react'
import GraduationCapIcon from '../../../src/assets/assistantIcon/graduationCap.svg?react'
import CommentCheckIcon from '../../../src/assets/assistantIcon/commentCheck.svg?react'


interface Props {
    id: string
}

export const AssistantIcon: FC<Props> = ({ id }) => {
    const assistantIcon = useMemo(() => {
        switch (id) {
            case 2:
                return <ConfettiIcon  height='16px' width='16px' />
            case 10:
                return <AppleIcon height='16px' width='16px' />
            case 11:
                return <MegaphoneIcon height='16px' width='16px' />
            case 12:
                return <SmileIcon height='16px' width='16px'  />
            case 13:
                return <PlayingCardsIcon height='16px' width='16px' />
            case 14:
                return <CommentUserIcon height='16px' width='16px' />
            case 15:
                return <MoonIcon height='16px' width='16px' />
            case 16:
                return <SubtitlesIcon height='16px' width='16px' />
            case 17:
                return <TrophyIcon height='16px' width='16px' />
            case 19:
                return <BookIcon height='16px' width='16px' />
            case 20:
                return <ShoppingCartCheckIcon height='16px' width='16px' />
            case 21:
                return <VideoCameraIcon height='16px' width='16px' />
            case 23:
                return <BriefcaseIcon height='16px' width='16px' />
            case 24:
                return <ChartHistogramIcon height='16px' width='16px' />
            case 25:
                return <PictureIcon height='16px' width='16px' />
            case 26:
                return <TransformIcon height='16px' width='16px' />
            case 27:
                return <PawIcon height='16px' width='16px' />
            case 28:
                return <PawIcon height='16px' width='16px' />
            case 29:
                return <HeadSideThinkingIcon height='16px' width='16px' />
            case 31:
                return <TreatmentIcon height='16px' width='16px' />
            case 32:
                return <TimeQuarterToIcon height='16px' width='16px'  />
            case 33:
                return <LabelIcon height='16px' width='16px' />
            case 34:
                return <GymIcon height='16px' width='16px' />
            case 35:
                return <GraduationCapIcon height='16px' width='16px' />
            case 36:
                return <CommentCheckIcon height='16px' width='16px' />
        }
    }, [id])

    return assistantIcon
}
